import { MeshBasicMaterial, TextureLoader, Vector3, PlaneGeometry, BoxGeometry, DoubleSide, MeshMatcapMaterial, MeshStandardMaterial } from 'three';
import { OBJLoader } from 'three/addons/loaders/OBJLoader.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { FontLoader } from 'three/addons/loaders/FontLoader.js';

const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');

export const TEXTURE_LOADER = new TextureLoader();
export const OBJ_LOADER = new OBJLoader();
export const GLTF_LOADER = new GLTFLoader();
export const DRACO_LOADER = new GLTFLoader();
DRACO_LOADER.setDRACOLoader(dracoLoader);
export const FONT_LOADER = new FontLoader();

export const CENTER = new Vector3();

export const SETTINGS = {
    opacity: 1,
    fov: 50,
    near: 1,
    far: 25000,
    factor: 20,
    camera2D: true,
    cameraPos: new Vector3(0, 0, 1500),
    lookAt: CENTER,
    controls: false,
    clearColor: '#02024c',
    clearColorAlpha: 0,
    noiseIntensity: 1.130,
    mouseX: 4.46,
    mouseY: 2.5,
    mouseLerp: .024,
    cameraLookAtLerp: .062,
    cameraLerp: .04,
    groupRotation: true,
    cameraRotation: false
}

export const MATCAP_MATERIAL = new MeshMatcapMaterial();
export const BASIC_MATERIAL = new MeshBasicMaterial({ color: 0x0000FF, side: DoubleSide });
export const STANDARD_MATERIAL = new MeshStandardMaterial();
export const BOX_GEOMETRY = new BoxGeometry();
export const PLANE_GEOMETRY = new PlaneGeometry();
export const DEPTH_PLANE_GEOMETRY = new PlaneGeometry(1, 1, 128, 128);
